import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgContainerApps = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-container-apps';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.68 3.267c-2.157.114-3.833 1.545-4.301 3.673-.039.176-.09.333-.115.349a.4.4 0 0 1-.179.03c-.201.001-1.009.191-1.402.329a7 7 0 0 0-1.443.727c-.369.253-1.01.883-1.228 1.205-.444.661-.673 1.312-.753 2.15l-.025.27H3.76v-.162c0-.224.111-.695.225-.953.193-.438.651-.966 1.113-1.283a6.3 6.3 0 0 1 1.142-.561c.563-.191.91-.245 1.73-.269l.79-.023v-.527c0-.572.038-.859.168-1.262C9.27 5.895 10 5.167 11.022 4.873c.274-.079.41-.092.978-.092s.704.013.978.092c1.058.304 1.783 1.053 2.127 2.195.091.302.109.447.125 1.022l.019.67h.586c1.205.001 2.15.25 2.939.775.97.645 1.466 1.649 1.466 2.965 0 1.288-.483 2.291-1.41 2.93a3.6 3.6 0 0 1-1.053.522c-.737.247-.836.258-2.367.277l-1.41.017v1.522l1.37-.019c1.692-.022 2.124-.087 3.135-.467 1.686-.634 2.764-1.887 3.141-3.651.126-.59.126-1.672 0-2.262-.338-1.579-1.196-2.7-2.61-3.411-.646-.324-1.252-.505-2.201-.657-.142-.022-.146-.028-.193-.272a5.7 5.7 0 0 0-.472-1.323c-.847-1.648-2.497-2.544-4.49-2.439M5.39 13.37l-2.11 1.207v4.852l2.111 1.206c1.161.663 2.131 1.205 2.155 1.205s.992-.541 2.149-1.203l2.105-1.203v-4.868l-2.105-1.203c-1.157-.662-2.125-1.202-2.15-1.202-.025.001-.995.545-2.155 1.209m3.533 1.28 1.354.77.001 1.58.001 1.58-1.363.777-1.363.777-.127-.069c-.069-.038-.684-.388-1.366-.778l-1.24-.71v-3.148l1.34-.771a45 45 0 0 1 1.375-.774c.019-.002.644.343 1.388.766"
    })
  }));
});
export default SvgContainerApps;